module.exports = __webpack_public_path__ + "img/ic-active-whatsapp.0a39a408.svg";